import { Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';

/**
 * Legacy URL redirects for bookmarks and old links.
 * Target paths use the dashboard app (/dashboard/*) where features now live.
 */
export const legacyRoutes = (
  <>
    <Route path="/marketing-hub/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/marketing/hub/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/coming-soon/marketing-suite" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/marketing/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />

    <Route path="/accounts/tax" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/accounts-suite/tax" replace />
      </ProtectedRoute>
    } />
    <Route path="/accounts/sales-summary" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/accounts-suite/sales-summary" replace />
      </ProtectedRoute>
    } />
    <Route path="/accounts/payments" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/accounts-suite/banking" replace />
      </ProtectedRoute>
    } />
    <Route path="/accounts/invoicing" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/accounts-suite/invoicing" replace />
      </ProtectedRoute>
    } />

    <Route path="/hr/staff-users/new" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/employee-suite/staff-users/new" replace />
      </ProtectedRoute>
    } />
    <Route path="/hr/staff-users/:employeeId/edit" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/employee-suite/staff-users" replace />
      </ProtectedRoute>
    } />
    <Route path="/hr/staff-users/:employeeId" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/employee-suite/staff-users" replace />
      </ProtectedRoute>
    } />
    <Route path="/hr/staff-users" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/employee-suite/staff-users" replace />
      </ProtectedRoute>
    } />
    <Route path="/hr/staff-scheduling" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/employee-suite/staff-scheduling" replace />
      </ProtectedRoute>
    } />
    <Route path="/hr/shift-management" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/employee-suite/shift-management" replace />
      </ProtectedRoute>
    } />
    <Route path="/hr/payroll" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/employee-suite/payroll" replace />
      </ProtectedRoute>
    } />
    <Route path="/hr/notifications" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/employee-suite/notifications" replace />
      </ProtectedRoute>
    } />

    <Route path="/settings/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/settings-new" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />

    <Route path="/items/departments/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/services/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/services" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/laundry-suite/services" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/modifiers/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/add" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/edit/:id" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/view/:id" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/departments/add" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/departments/edit/:id" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/dry-cleaning-suite/departments/edit" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/departments/view/:id" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/dry-cleaning-suite/departments/view" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/library/add" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/retail-suite/products/add" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/library/edit/:id" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/retail-suite/products/edit" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/library/view/:id" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/retail-suite/products/view" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/library" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/retail-suite/products" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/images" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/retail-suite/image-library" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/modifiers/add" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/dry-cleaning-suite/modifiers/add" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/service-based-modifiers" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/dry-cleaning-suite/modifiers" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/categories/add" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/dry-cleaning-suite/categories/add" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/categories/view/:id" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/dry-cleaning-suite/categories/view" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/categories/:id/edit" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/dry-cleaning-suite/categories" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/categories" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/dry-cleaning-suite/categories" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/options" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/units" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/items/modifiers" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/dry-cleaning-suite/modifiers" replace />
      </ProtectedRoute>
    } />
    <Route path="/items" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/dry-cleaning-suite/items" replace />
      </ProtectedRoute>
    } />
    <Route path="/departments" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />

    <Route path="/laundry/services" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/laundry-suite/services" replace />
      </ProtectedRoute>
    } />
    <Route path="/laundry/add-ons" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/laundry-suite/modifiers" replace />
      </ProtectedRoute>
    } />

    <Route path="/labels/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/dry-cleaning/*-labels" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />

    <Route path="/dry-cleaning/stores" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/stores/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/dry-cleaning/location-role" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/dry-cleaning/weighted-laundry" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/dry-cleaning/pickup-delivery/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/dry-cleaning/plant-management" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />

    <Route path="/rewards/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
    <Route path="/customers" element={<Navigate to="/dashboard" replace />} />
    <Route path="/groups" element={<Navigate to="/dashboard" replace />} />

    <Route path="/reports" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/accounts-suite/sales-summary" replace />
      </ProtectedRoute>
    } />
  </>
);
